// extracted by mini-css-extract-plugin
export default {"logo":"Styles-module__logo--d720"};